import { GridOverlay } from '@mui/x-data-grid'
import TableLoadingState from './TableLoadingState'

/** DataGrid loading overlay matching list-table loaders. */
export default function GridLoadingOverlay() {
  return (
    <GridOverlay>
      <div style={{ width: '100%', padding: '8px 0' }}>
        <TableLoadingState compact />
      </div>
    </GridOverlay>
  )
}
